
import { defineComponent } from 'vue'

export default defineComponent({
    name: "Zone Text",
    data: ()=>({
        content: { } as any
    }),

    props: {
        zoneContent: {
            type: Object,
            default: null
        },
        zoneNumber: {
            type: Number,
            default: null
        },
        zoneType: {
            type: String,
            default: null
        },
        contentName: {
            type: String,
            default: null
        }
    },

    async created() {
        this.content = {
            text: this.zoneContent && this.zoneContent.content.text ? this.zoneContent.content.text : ''
        }
    },

    watch: {
        content: {
            handler(newValue: any) {
                const current = this.zoneContent?.content ?? {};
                if (JSON.stringify(newValue) !== JSON.stringify(current)) {
                    this.$emit('updateSignageZones', {
                        zoneNumber: this.zoneNumber,
                        zoneType: this.zoneType,
                        updatedContent: newValue
                    });
                }
            },
            deep: true
        },

        zoneContent: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (!newVal || typeof newVal !== 'object' || !newVal.content) {
                    this.content = {
                        text: ''
                    };
                    return;
                }

                const content = newVal.content;

                const newVals = {
                    text: content.text ?? ''
                };

                if (JSON.stringify(this.content) !== JSON.stringify(newVals)) {
                    this.content = newVals;
                }
            }
        }
    }
})
